<div class="card-link-earn-step-box border-0 rounded shadow py-3 px-lg-4">
  <h5 class="card-title text-center fw-bold">{{ cardTitle | translate }}</h5>
  <hr class="vertical-line" *ngIf="horizontalLine" />
  <div class="row">
    <div class="col-lg-4 col-12">
      <!--Col 1-->
      <div class="d-flex flex-column flex-nowrap mx-2 py-2 align-items-start">
        <div class="d-flex flex-row justify-content-center align-items-start">
          <div class="card-link-earn-step-icon centered position-relative ms-lg-3 ms-4">
            <div class="card-link-earn-step-number position-absolute centered color-1">1</div>
            <span
              [ngClass]="{ 'card-link-earn-step-icon-border-1': border, 'card-link-earn-step-icon-filled-1': filled }"
              class="icon icon1 material-icons color-1"
              aria-hidden="true"
              >{{ stepOneIcon }}</span
            >
          </div>
          <div class="ps-3 pe-lg-2">
            <div class="step-1-text font-size-12">{{ stepOneText | translate }}</div>
            <div class="step-texts-small-print-text">{{ stepOneSmallPrintText | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-12">
      <!--Col 2-->
      <div class="d-flex flex-column flex-nowrap mx-2 py-2 align-items-start">
        <div class="d-flex flex-row justify-content-center align-items-start">
          <div class="card-link-earn-step-icon centered position-relative ms-lg-3 ms-4">
            <div class="card-link-earn-step-number position-absolute centered color-2">2</div>
            <span
              [ngClass]="{ 'card-link-earn-step-icon-border-2': border, 'card-link-earn-step-icon-filled-2': filled }"
              class="icon icon2 material-icons ecash-description color-2"
              aria-hidden="true"
              >{{ stepTwoIcon }}</span
            >
          </div>
          <div class="ps-3 pe-lg-2">
            <div class="step-2-text font-size-12">{{ stepTwoText | translate }}</div>
            <div class="step-texts-small-print-text">{{ stepTwoSmallPrintText | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-12">
      <!--Col 3-->
      <div class="d-flex flex-column flex-nowrap mx-2 py-2 align-items-start">
        <div class="d-flex flex-row justify-content-center align-items-start">
          <div class="card-link-earn-step-icon centered position-relative ms-lg-3 ms-4">
            <div class="card-link-earn-step-number position-absolute centered color-3">3</div>
            <span
              [ngClass]="{ 'card-link-earn-step-icon-border-3': border, 'card-link-earn-step-icon-filled-3': filled }"
              class="icon icon3 material-icons ecash-description color-3"
              aria-hidden="true"
              >{{ stepThreeIcon }}</span
            >
          </div>
          <div class="ps-3 pe-lg-2">
            <div class="step-3-text font-size-12">{{ stepThreeText | translate }}</div>
            <div class="step-texts-small-print-text">{{ stepThreeSmallPrintText | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
